<template>
 <van-config-provider :theme-vars="themeVars">
   <div class="van-hairline--surround">
        <van-cell-group inset border="false">
          <h3 style="padding-top: 1em;">消息盒子</h3>
          <p class="textIndentation">消息盒子是您绑定的机构，向您推送的信息，请您查阅！
          </p>
        </van-cell-group>
    </div>
  </van-config-provider>
   <van-list
  v-model:loading="loading"
  :finished="finished"
  finished-text="没有更多了"
  @load="onLoad"
    >
    <div class="items_box" v-for="(playerFilesVo, messageId) in articleList.playerFilesVo" :key="messageId">
        <div class="item-left">
            <van-image class="img-style" :src="playerFilesVo.imgUrl" />
        </div>
        <div class="item-right">
            <div class="top-title">
                {{ playerFilesVo.title }}
            </div>
            <div class="buttom-desc">
                {{ playerFilesVo.simpleDesc }}
            </div>
            <div class="buttom-right">
                <van-button type="primary" size="small" plain @click="getNewData(playerFilesVo.messageId)">详情</van-button>
            </div>
        </div>
    </div>
</van-list>
</template>
<script>
import {ref,reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { postUserLog } from "../../api/userlog";
import {postArticleList } from '../../api/article'
export default {
    setup() {
        const router = useRouter();
        const ulog = reactive({
            UserLog: {
                 path: "",
            },
        });
        const articleList = reactive({
             playerFilesVo: {
                    title: '',
                    messageId: '',
                    imgUrl:'',
                    simpleDesc:''
      }
    });
        const list = ref([]);
        const loading = ref(false);
        const finished = ref(false);
        const themeVars = reactive({
            cellGroupBackground: '#F1F1F1',
        });
        const getNewData = (res) => { 
            console.log(res)
            router.push({
                path: 'article',
                query: {messageId:res}
          });   
        };
        const onLoad = () => {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                for (let i = 0; i < 5; i++) {
                list.value.push(list.value.length + 1);
            }

            // 加载状态结束
            loading.value = false;

            // 数据全部加载完成
            if (list.value.length >= 20) {
                finished.value = true;
            }
         }, 1000);
         };
        onMounted(() => {
            postArticleList().then((res) =>{
                articleList.playerFilesVo=res.data.data;
                console.log(articleList);
             })
            ulog.UserLog.path = router.currentRoute.value.fullPath;
            console.log("当前页面路径==" + ulog.UserLog.path);
            postUserLog(ulog.UserLog).then(() => {});

        })
        return {
            list,
            onLoad,
            loading,
            themeVars,
            finished,
            getNewData,
            articleList,
        }
    },
    methods: {
     
    }
}

</script>
<style lang="scss" scoped>
html,body{
    padding: 0;
    margin: 0;
}
.items_box{
    margin: 10px;
    border-radius: 15px;
    background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
    display: flex;
    flex-flow: row nowrap;
    .item-left{
        .img-style{
        margin: 10px;
        width: 120px;
        height: 80px;
        }
    }
    .item-right{
        margin-left: 30px;
        text-align: left;
        .top-title{
            margin-top: 10px;
            font-size: 16px;
        }
        .buttom-desc{
            margin-top:10px;
            font-size: 10px;
        }
        .buttom-right{
            text-align: right;
        }
    }

}

</style>
